<!-- Allows changing font size, theme, etc. -->

<script lang="ts">
	import { Button } from '$lib/components/ui/button';
	import {
		DropdownMenu,
		DropdownMenuContent,
		DropdownMenuLabel,
		DropdownMenuSeparator,
		DropdownMenuRadioGroup,
		DropdownMenuRadioItem,
		DropdownMenuTrigger,
		DropdownMenuSub,
		DropdownMenuSubTrigger,
		DropdownMenuSubContent,
		DropdownMenuItem
	} from '$lib/components/ui/dropdown-menu';
	import { Type, Moon, Sun, Monitor, Palette } from 'lucide-svelte';
	import { setMode, resetMode } from 'mode-watcher';
	import type { ReaderFontSize } from '$lib/types/reader';
	import { readerStore } from '$lib/stores/reader-store.svelte';
	import { KEY_READER_FONT_SIZE } from '$lib/storage';

	function handleFontSizeChange(value: string) {
		const newSize = value as ReaderFontSize;
		readerStore.fontSize = newSize;
		// Persist changes
		localStorage.setItem(KEY_READER_FONT_SIZE, readerStore.fontSize);
	}
</script>

<DropdownMenu>
	<DropdownMenuTrigger>
		<Button variant="ghost" size="icon" class="rounded-full">
			<Type class="h-4 w-4" />
			<span class="sr-only">Reader settings</span>
		</Button>
	</DropdownMenuTrigger>
	<DropdownMenuContent align="end">
		<DropdownMenuLabel>Font Size</DropdownMenuLabel>
		<DropdownMenuSeparator />
		<DropdownMenuRadioGroup value={readerStore.fontSize} onValueChange={handleFontSizeChange}>
			<DropdownMenuRadioItem value="small">Small</DropdownMenuRadioItem>
			<DropdownMenuRadioItem value="medium">Medium</DropdownMenuRadioItem>
			<DropdownMenuRadioItem value="large">Large</DropdownMenuRadioItem>
		</DropdownMenuRadioGroup>
		<DropdownMenuSeparator />
		<DropdownMenuSub>
			<DropdownMenuSubTrigger>
				<Palette class="mr-2 size-4" />
				<span>Theme</span>
			</DropdownMenuSubTrigger>
			<DropdownMenuSubContent>
				<DropdownMenuItem onclick={() => setMode('light')} class="flex items-center gap-2">
					<Sun class="size-4" />
					<span>Light</span>
					<span class="ml-auto block dark:hidden">✓</span>
				</DropdownMenuItem>
				<DropdownMenuItem onclick={() => setMode('dark')} class="flex items-center gap-2">
					<Moon class="size-4" />
					<span>Dark</span>
					<span class="ml-auto hidden dark:block">✓</span>
				</DropdownMenuItem>
				<DropdownMenuItem onclick={() => resetMode()} class="flex items-center gap-2">
					<Monitor class="size-4" />
					<span>Auto</span>
				</DropdownMenuItem>
			</DropdownMenuSubContent>
		</DropdownMenuSub>
	</DropdownMenuContent>
</DropdownMenu>
